import { Alert, AlertTitle, Box, Chip, Typography } from '@mui/material';
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined';
import React from 'react';

interface FeatureMessageProps {
  requiredFeatures: string[];
  requirementType: 'single' | 'any' | 'all';
}

export const FeatureMessage: React.FC<FeatureMessageProps> = ({
  requiredFeatures,
  requirementType,
}) => {
  const getMessage = () => {
    if (requiredFeatures.length === 0) return 'Feature not available';
    if (requiredFeatures.length === 1)
      return 'This feature is currently disabled:';
    switch (requirementType) {
      case 'any':
        return 'At least one of these features must be enabled:';
      case 'all':
        return 'All of these features must be enabled:';
      default:
        return 'This feature is currently disabled:';
    }
  };

  return (
    <Alert
      severity="info"
      icon={<ToggleOffOutlinedIcon />}
      data-testid="feature-message"
      sx={{
        backgroundColor: 'background.paper',
        border: 1,
        borderColor: 'divider',
      }}
    >
      <AlertTitle>Feature Disabled</AlertTitle>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {getMessage()}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {requiredFeatures.map((f) => (
          <Chip
            key={f}
            data-testid="feature-chip"
            label={f}
            size="small"
            variant="outlined"
            sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
          />
        ))}
      </Box>
    </Alert>
  );
};
